export class UICoreExtensionValueObject {
    
    isAUICoreExtensionValueObject = true
    value: any
    
    constructor(value: any) {
        
        this.value = value
        
    }
    
}
